import { Card, CbhIcon, Rating, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { CardActionArea, CardContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { useGetRatingAggregates } from "@src/appV2/redesign/Workplace/Review/api/useGetRatingAggregates";
import { generatePath, useHistory } from "react-router-dom";

interface WorkplaceCardProps {
  workplaceId: string;
  workplaceName: string;
  shiftId?: string;
}

export function WorkplaceCard(props: WorkplaceCardProps) {
  const { workplaceId, workplaceName, shiftId } = props;
  const history = useHistory();

  const { data: ratingAggregates } = useGetRatingAggregates(workplaceId, {
    enabled: isDefined(workplaceId),
  });

  const rating = ratingAggregates?.avgRating ?? 0;
  const numberOfRatings = ratingAggregates?.numberOfRatings ?? 0;

  const handleCardClick = () => {
    logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_WORKPLACE_CARD_TAPPED, {
      shiftId,
      workplaceId,
      sourceUI: "timekeeping-details",
    });

    const workplaceProfilePath = generatePath(SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH, {
      workplaceId,
    });
    history.push(workplaceProfilePath);
  };

  return (
    <Card>
      <CardActionArea onClick={handleCardClick}>
        <CardContent sx={{ padding: 7 }}>
          <Stack
            direction="row"
            spacing={6}
            alignItems={numberOfRatings > 0 ? "flex-start" : "center"}
          >
            <CbhIcon type="map-pin" size="large" />
            <Stack direction="column" spacing={6} sx={{ flex: 1 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Text semibold variant="h6">
                  {workplaceName}
                </Text>
                <CbhIcon type="chevron-right" sx={{ marginLeft: "auto" }} />
              </Stack>
              {numberOfRatings > 0 && (
                <Stack direction="row" spacing={2} alignItems="center">
                  <Rating readOnly value={rating} precision={0.1} size="medium" />
                  <Text variant="body2">
                    {rating.toFixed(1)} stars ({numberOfRatings} ratings)
                  </Text>
                </Stack>
              )}
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
